import { Map, fromJS } from 'immutable';

export function request(state) {
    return state.set(
        'create',
        (state.get('create') || Map())
            .set('state', 'IN_PROGRESS')
            .set('errors', void 0)
    );
}

export function error(state, { errors }) {
    return state.set(
        'create',
        (state.get('create') || Map())
            .set('state', 'ERROR')
            .set('errors', fromJS(errors))
    );
}

export function finish(state, { competition }) {
    return state
        .set(
            'create',
            (state.get('create') || Map())
                .set('competition', fromJS(competition))
                .set('state', 'FINISHED')
                .set('errors', void 0)
        );
}

export function clear(state) {
    return state.set('create', Map());
}
